/**
 * Account: who you are, and the credential that proves it.
 *
 * Name, email, password and the way out. Everything here is an endpoint - the
 * only fact without a control beside it is the email address, and it says in
 * words that it cannot be changed here rather than offering a disabled field.
 *
 * Sessions are deliberately *not* here. Ending a session on another machine is
 * a security action, and it lives with the other security actions rather than
 * beside a name field.
 */

import { useNavigate } from "react-router-dom";
import { Section } from "@/components/product";
import { Button } from "@/components/ui";
import { useAuth } from "@/features/auth/AuthGate";
import { paths } from "@/app/paths";
import { DisplayNameSetting, PasswordSetting } from "../AccountSettings";
import { Fact } from "./Fact";
import { useState } from "react";

export function AccountPanel() {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [signingOut, setSigningOut] = useState(false);

  return (
    <>
      <DisplayNameSetting />

      <Section title="Hesap">
        {/* The display name is not repeated here: it is the editable field
            above, and showing it a second time as a read-only row invites the
            reader to wonder which of the two is the real one. The email is a
            fact rather than a field because it genuinely cannot be changed
            from this screen, which the hint above already says. */}
        <Fact label="E-posta" value={user.email} />

        {/* In this section rather than one of their own: a heading that reads
            "Sign out" above a button that reads "Sign out" is the same word
            twice, and it makes the button ambiguous to anything - a test, a
            screen reader - that looks up controls by their text. */}
        <div className="settings__actions">
          <Button
            variant="danger"
            busy={signingOut}
            onClick={() => {
              setSigningOut(true);
              void signOut();
            }}
          >
            {"Oturumu Kapat"}
          </Button>
          <Button onClick={() => navigate(paths.about())}>
            {"Sürüm bilgisi"}
          </Button>
        </div>
      </Section>

      <PasswordSetting />
    </>
  );
}
